<script setup lang="ts">
import { StoryblokComponent } from '@storyblok/vue';

const props = defineProps({
    blok: {
        type: Object,
        default: () => ({}),
    },
});

const { market: currentRegion } = useMarket();

const shouldRender = computed(() => {
    return props.blok.visibleIn.includes(currentRegion.value);
});
</script>

<template>
    <StoryblokComponent
        v-if="shouldRender"
        v-for="item in blok.body"
        :key="item._uid"
        :blok="item"
    />
    <StoryblokComponent v-for="item in blok.bodyElse" v-else :ket="item._uid" :blok="item" />
</template>
